// game objects (with initial values)
const generateEnemy = () => ({
    id: Math.random(),
    posX:
      Math.random() < 0.5
        ? -(Math.random() * 500)
        : GAME_WIDTH + Math.random() * 500,
    posY: GROUND_HEIGHT,
    hp: 2,
    maxHP: 2,
    speed: 2 + (waveNumber / 10),
    attackSpeed: 1000, // 1 per second
    lastAttack: Date.now(),
    recoilSpeed: 0,
    isAttacking: false, // used for moving the sword
    reactionTimeInSteps: Number((Math.random() * 100).toFixed()), // time needed to change direction
    stepsToReact: null
  });
  
  const generateSkeleton = (posX) => ({
    id: Math.random(),
    posX,
    posY: GROUND_HEIGHT,
    hp: 4,
    maxHP: 4,
    speed: [0.6, 0.8, 1, 1.1][Math.floor(Math.random() * 4)],
    attackSpeed: 2500,
    lastAttack: Date.now(),
    isAttacking: false
  });
  
  const generateRandomItemKind = () => {
    const n = Math.random();
    if (n < 0.5) {
      return ITEMS.MANA;
    } else if (n < 0.8) {
      return lives < maxLives ? ITEMS.HEAL : ITEMS.MANA;
    } else if (n < 0.95) {
      return ITEMS.POWERUP;
    } else if (n >= 0.95) {
      return ITEMS.EXTRA_LIFE;
    }
  };
  
  const generateItem = () => ({
    id: Math.random(),
    posX: Math.random() * GAME_WIDTH,
    posY: 10,
    kind: generateRandomItemKind(),
    speedUp: 0,
  });
  
  const generateBoss = () => ({
    id: Math.random(),
    posX:
      Math.random() < 0.5
        ? Math.floor(-(Math.random() * 300))
        : Math.floor(GAME_WIDTH + Math.random() * 300),
    posY: GROUND_HEIGHT,
    hp: 8,
    maxHP: 8,
    speed: 1 + (waveNumber / 10),
    attackSpeed: 1000, // 1 per second
    lastAttack: Date.now(),
    isBoss: true,
    recoilSpeed: 0,
    isAttacking: false,
    reactionTimeInSteps: Number((Math.random() * 100).toFixed()), // time needed to change direction
    stepsToReact: null
  });

  const generateStarBackground = (numberOfStars) => {
    while (numberOfStars--) {
      const x = Math.floor(Math.random() * GAME_WIDTH);
      const y = Math.floor((Math.random() * (GAME_HEIGHT - 240)));
      stars.push([x, y]);
    }
  };

  // const generateTrees = (numberOfTrees) => {
  //   while (numberOfTrees--) {
  //     trees.push({
  //       id: Math.random(),
  //       posX: Math.floor(Math.random() * GAME_WIDTH),
  //       // branches: Math.floor(Math.random() * 5 + 4),
  //       height: Math.floor(Math.random() * 100 + 50),
  //       // generate branch points
        
  //     })
  //   }
  // };